import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		chipContainer: {
			marginTop: 10,
		},
		chip: {
			margin: theme.spacing(0.5),
			fontSize: "1rem",
		}

	} satisfies Record<string, CSSObject>;
};
